export default __webpack_public_path__ + "9c0c91174a4734487a03bf35b745638e.png";